<template>
    <div class="flex items-center gap-[1px]">
        <div class="h-5 w-5 bg-[#05b67a] text-white rounded-sm">
            <StarIcon class="h-5 w-5 p-0.5" />
        </div>

        <div class="h-5 w-5 bg-[#05b67a] text-white rounded-sm">
            <StarIcon class="h-5 w-5 p-0.5" />
        </div>

        <div class="h-5 w-5 bg-[#05b67a] text-white rounded-sm">
            <StarIcon class="h-5 w-5 p-0.5" />
        </div>

        <div class="h-5 w-5 bg-[#05b67a] text-white rounded-sm">
            <StarIcon class="h-5 w-5 p-0.5" />
        </div>

        <div class="relative h-5 w-5 bg-[#05b67a] text-white rounded-sm overflow-hidden">
            <div class="absolute right-0 w-1/2 h-full bg-gray-300"></div>
            <StarIcon class="relative z-10 h-5 w-5 p-0.5" />
        </div>
    </div>
</template>

<script>
import {StarIcon} from "@heroicons/vue/solid";

export default {
    components: {
        StarIcon,
    }
}
</script>
